import { apiClient } from "../apiClient";

const DOT_THI_ENDPOINT = "dot-thi";
export const dotThiApi = {
    SelectAll: () => apiClient.get(`${DOT_THI_ENDPOINT}`),
}